export default __webpack_public_path__ + "static/media/tago-screenshot-05.685fa182.png";